<div class="share-popup">
    <p-dialog  [(visible)]="_share.displayShare" [modal]="true" [style]="{ width: '450px', }" [draggable]="false" [resizable]="false">
        <ng-template pTemplate="header">
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class="white-space-nowrap">Share</span>
            </div>
            <div class="close-popup" (click)="_share.displayShare=false">
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt="close"
                  loading="lazy" ngOptimizedImage>
            </div>
        </ng-template>
        <div class="product-strip">
            <div class="p-img">
                <img ngOptimizedImage height="80" width="80" [src]="_share.share_item_image_url" [alt]="_share.share_item_name" loading="lazy">
            </div>
            <div class="p-text">
                <p>{{_share.share_item_name}}</p>
                <span class="share-link-span">{{_share.share_link}}</span>
    
            </div>
        </div>
        <div class="social-share-box">
            <share-buttons [theme]="'circles-dark'" [url]="_share.share_link"
                            [include]="['whatsapp','facebook','pinterest','linkedin',]" [show]="4"
                            [tags]="'afterbricks'" >
                        </share-buttons>
        </div>
       <div class="copy-link-box" *ngIf="!isCopyed" (click)="copyLink()">
                <div>
                    <label >Copy link</label>
                </div>
                <div>
                    <span><i class="fa fa-clone" aria-hidden="true"></i></span>
                </div>
       </div>
       <div class="copy-link-box" *ngIf="isCopyed">
        <span class="text-success">Link copied!</span>
       </div>
    </p-dialog>
    
</div>